import type { ChatMessage } from "@/lib/chat/map-api-message"

export type MessageReportPayload = {
  itemType: "message" | "message photo"
  itemId: string
  itemTitle?: string
  reportedUserId: string
  reportedUsername?: string | null
  reportedAvatarUrl?: string | null
}

function isImageOnlyMessage(message: ChatMessage): boolean {
  const token = (message.content ?? "").trim().toLowerCase()
  return Boolean(message.imageUrl) && (token.length === 0 || token === "[image]" || token === "[images]")
}

export function resolveMessageReportPayload(
  message: ChatMessage,
  ctx: {
    isOwnMessage: boolean
    reportedUsername?: string | null
    reportedAvatarUrl?: string | null
    itemTitle?: string
  },
): MessageReportPayload | null {
  if (ctx.isOwnMessage || message.pending || !message.id) return null
  const reportedUserId = message.senderId ?? message.user?.name
  if (!reportedUserId) return null
  return {
    itemType: isImageOnlyMessage(message) ? "message photo" : "message",
    itemId: message.id,
    itemTitle: ctx.itemTitle,
    reportedUserId,
    reportedUsername: ctx.reportedUsername ?? null,
    reportedAvatarUrl: ctx.reportedAvatarUrl ?? null,
  }
}
